import React, { useEffect } from "react";
import { Table, TableBody, TableCell, TableRow } from "../../../design/table";
import { Subheading } from "../../../design/heading";
import EventSubtypeBadge from "../../../components/EventSubtypeBadge";
import { useEventType } from "../../../contexts/EventTypeContext";
import EmptyStateView from "../../../components/EmptyStateView";
import { PlusIcon } from "@heroicons/react/16/solid";
import EventSubtypeButton from "../../../components/EventSubtypeButton";

interface EventTypeEventsListProps {
  eventTypeId: string;
}

const EventTypeEventsList: React.FC<EventTypeEventsListProps> = ({
  eventTypeId,
}) => {
  const { eventSubtypes } = useEventType();
  const items = eventSubtypes.filter((item) => item.eventType === eventTypeId);
  return (
    <div className="mt-6">
      <div className="flex items-center justify-between">
        <Subheading>Event Subtypes</Subheading>
        <EventSubtypeButton eventTypeId={eventTypeId}>
          <PlusIcon />
        </EventSubtypeButton>
      </div>
      {items.length === 0 && (
        <EmptyStateView
          title="No Event Subtypes"
          message="No event subtypes found for this event type."
        />
      )}
      {items.length > 0 && (
        <Table>
          <TableBody>
            {items.map((eventSubtype) => {
              return (
                <TableRow
                  key={eventSubtype._id}
                  href={`/event-subtype/${eventSubtype._id}`}
                >
                  <TableCell className={"flex gap-2"}>
                    <EventSubtypeBadge
                      eventSubtypeId={eventSubtype._id}
                      eventSubtypes={eventSubtypes}
                    />
                    {eventSubtype.description}
                  </TableCell>
                  <TableCell width={20}>
                    {eventSubtype.numberOfEvents ?? 0}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default EventTypeEventsList;
